/*
 * Contenido pendiente de completar: TODO lo que hay que cambiar está aquí.
 *
 * - publicada: false → la página existe y se puede revisar en su URL, pero no
 *   aparece en el menú ni en el pie, y Google no la indexa. En desarrollo
 *   (npm run serve) y en "npm run preview" se ve siempre, con un aviso.
 * - Cuando el texto esté listo: rellénalo en el fichero de la página
 *   (src/contenido/*.js) y cambia publicada a true.
 */

export const MOSTRAR_BORRADORES = process.env.NODE_ENV !== "production" || process.env.VUE_APP_MOSTRAR_BORRADORES === "on";

export const PAGINAS = {
  historia: { publicada: false, ruta: "historia" },
  sanJudas: { publicada: false, ruta: "sanJudas" },
  caritasColabora: { publicada: false, ruta: "caritasColabora" },
};

/** ¿Se enlaza la página desde el menú y el pie? */
export function paginaVisible(clave) {
  const p = PAGINAS[clave];
  return !!p && (p.publicada || MOSTRAR_BORRADORES);
}

/*
 * Canal de WhatsApp de la parroquia.
 * Cuando exista: WhatsApp → Novedades → Canales → tu canal → Compartir enlace,
 * y pega aquí la dirección (https://whatsapp.com/channel/...).
 * Mientras esté vacío, el botón aparece como "Próximamente" y no se puede pulsar.
 */
export const CANAL_WHATSAPP = "";

/*
 * Cáritas · Colabora. Datos de DEMOSTRACIÓN: sustitúyelos por los reales y pon
 * demo a false (desaparece el aviso "Datos de ejemplo").
 */
export const CARITAS_DONATIVOS = {
  demo: true,
  bizum: "00000", // código de ONG de Bizum (5 cifras)
  iban: "ES00 0000 0000 0000 0000 0000",
  titular: "Cáritas Parroquial de Santo Domingo",
  concepto: "Donativo Cáritas Santo Domingo",
  // Formulario de voluntariado: false = modo demostración (no envía nada);
  // true = abre el correo del visitante con la solicitud ya escrita para Cáritas.
  formularioActivo: false,
};
